import { useEffect, useState } from 'react'
import { checkwithremovemonth, fetchData, toasterrormsg, toastsuccessmsg, useMenuIdPermissions } from '../../../reusable'
import 'react-phone-input-2/lib/style.css'
import 'react-phone-input-2/lib/bootstrap.css'
import 'react-datepicker/dist/react-datepicker.css'
import { ToastContainer } from 'react-toastify'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faMinus, faPlus } from '@fortawesome/free-solid-svg-icons'
import { Tr } from '../../../_metronic/i18n/Tr'
import PriceInput from '../components/PriceInput'

function PointSystem() {
  let t = Tr()
  const { menuIdEdit } = useMenuIdPermissions()

  interface UpgradedTask {
    title: string
    value: string
  }

  interface BadgeData {
    degrees: string
    badges: string
    upgradedtasks: UpgradedTask[]
    reward: string
    recognition: string
    // Add other properties as needed
  }

  const [data, setData] = useState<BadgeData[]>([])

  const [adminData, setAdminData] = useState(Object)
  const [pointSystemList, setPointSystemList] = useState([
    { loyaltysettingId: '', point: '', availability: '', amount: '', compare: '' },
  ])
  const [reviewsList, setReviewsList] = useState([])
  const [explorePostList, setExplorePostList] = useState([])
  const [bonusList, setBonusList] = useState([])
  const [error, setError] = useState(Object)
  const [amount, setAmount] = useState("") as any
  const [point, setPoint] = useState("")
  const [loading, setLoading] = useState(false)

  useEffect(() => {
    document.title = 'Insayr | Point System'
    var store: any = sessionStorage.getItem('admin')
    setAdminData(JSON.parse(store))
  }, [])


  const removeError = (err: any) => {
    // Ensure error is an array before spreading
    var tmp = Array.isArray(error) ? [...error] : [{}]
    // Ensure the first object exists
    if (!tmp[0]) tmp[0] = {}

    tmp[0][err] = '' // Clear the specific error key
    setError(tmp)
  }


  const addbookingrow = async () => {
    var tmp: any = [
      ...pointSystemList,
      { id: '', point: 0, availability: 0, amount: 0, equal: 'Grater Than Equal to' },
    ]
    setPointSystemList(tmp)
  }
  const removebookingrow = async (index: any) => {
    var tmp: any = pointSystemList.filter((item: any, ind: any) => ind != index)
    setPointSystemList(tmp)
  }

  const onchange = (column: any, value: any, index: any) => {
    var tmp: any = [...pointSystemList]
    tmp[index][column] = checkwithremovemonth(value, tmp[index][column])
    setPointSystemList(tmp)
  }

  // call API start
  const selectLoyaltySettingAPICall = async () => {
    var param = {}
    var res = await fetchData('admin/selectLoyaltySetting', param)
    if (res.status == 200) {
      var tmp = res.data
        .filter((item: any) => item.type == 'Reviews')
        .map((item: any) => {
          return {
            loyaltysettingId: item.loyaltysettingId,
            point: item.point,
            amount: item.amount,
            availability: item.availability,
            label: item.label,
          }
        })
      setReviewsList(tmp)

      var tmp = res.data
        .filter((item: any) => item.type == 'Explore Posts')
        .map((item: any) => {
          return {
            loyaltysettingId: item.loyaltysettingId,
            point: item.point,
            amount: item.amount,
            availability: item.availability,
            label: item.label,
          }
        })
      setExplorePostList(tmp)

      var tmp = res.data
        .filter((item: any) => item.type == 'Booking')
        .map((item: any) => {
          return {
            loyaltysettingId: item.loyaltysettingId,
            point: item.point,
            amount: item.amount,
            availability: item.availability,
            label: item.label,
            compare: item.compare,
          }
        })
      setPointSystemList(tmp)

      var tmp = res.data
        .filter((item: any) => item.type == 'Bonus')
        .map((item: any) => {
          return {
            loyaltysettingId: item.loyaltysettingId,
            point: item.point,
            amount: item.amount,
            availability: item.availability,
            label: item.label,
            compare: item.compare,
          }
        })
      setBonusList(tmp)
    } else {
      toasterrormsg(res.message)
    }
  }
  const getBadgeSystemList = async () => {
    try {
      const response = await fetchData('admin/getbadgesdetaillist', Object, 'GET')
      if (response.status === 200) {
        const badgesData = response.data.map((badge: any) => {
          // Ensure upgradedtasks is always an array
          const upgradedtasks = badge.upgradedtasks
            ? Array.isArray(badge.upgradedtasks)
              ? badge.upgradedtasks
              : Object.entries(badge.upgradedtasks).map(([key, value]) => ({
                title: key,
                value,
              }))
            : [{ title: '', value: '' }]
          return {
            ...badge,
            upgradedtasks,
            recognition: badge.recognition || '', // Initialize recognition
          }
        })
        setData(badgesData)
      } else {
        toasterrormsg('Failed to fetch data')
      }
    } catch (error) {
      toasterrormsg('Failed to fetch data')
    }
  }

  const onSubmit = async (type: any) => {
    var param: any = {
      adminId: adminData['adminId'],
    }
    var API = 'admin/addUpdateBooking'

    if (type == 'booking') {
      param['type'] = 'Booking'
      param['response'] = pointSystemList
    } else if (type == 'review') {
      param['response'] = reviewsList
      API = 'admin/updateReviewReward'
    } else if (type == 'post') {
      param['response'] = explorePostList
      API = 'admin/updateReviewReward'
    }
    var res = await fetchData(API, param)
    if (res.status == 200) {
      if (type == 'booking') {
        param['type'] = 'Bonus'
        param['response'] = bonusList
        var res = await fetchData(API, param)
        if (res.status == 200) {
          toastsuccessmsg('Success')
        } else {
          toasterrormsg(res.message)
        }
      } else {
        toastsuccessmsg('Success')
      }
    } else {
      toasterrormsg(res.message)
    }
  }

  const validate = (data: any[]) => {
    for (let item of data) {
      // Check if any upgradedtasks value is empty

      // Check if reward is empty
      if (item.reward === '') {
        return false
      } else if (/^(0+)$/.test(item.reward)) {
        return false
      }
    }

    return true
  }

  const handleChange = (index: number, key: string, value: any, key2?: any) => {
    if (!/^\d*$/.test(value)) {
      return // Exit early if the value is not numeric
    }
    setData((prevData) => {
      const newData: any = [...prevData]
      if (key2 != null && key2 != '') {
        newData[index][key][key2] = value
      } else {
        newData[index][key] = value
      }

      return newData
    })
  }

  const onSubmit2 = async () => {
    let adminId = ''
    const adminDataString = sessionStorage.getItem('admin')

    if (adminDataString) {
      const adminData = JSON.parse(adminDataString)
      adminId = adminData.adminId
    }

    if (!validate(data)) {
      toasterrormsg('All Fields Are Requried')
      return // Exit early if validation fails
    }

    try {
      const param = {
        adminId: adminId,
        updateBadgesDetailData: data,
      }

      const res = await fetchData('admin/updatebadgesdetaillist', param)
      if (res.status === 200) {
        toastsuccessmsg(res.message)
        getBadgeSystemList()
      } else {
        toasterrormsg(res.message)
      }
    } catch (error) {
      toasterrormsg('Failed to submit form')
    }
  }

  useEffect(() => {
    selectLoyaltySettingAPICall()
    getBadgeSystemList()
  }, [])


  const equivalencyDataApiCall = async () => {

    var res = await fetchData('admin/viewpointsequivalency ', {})

    if (res.status == '200') {
      var data = res.data
      setAmount(data.amount)
      setPoint(data.point)
    } else {
      toasterrormsg(res.message)
    }
  }


  // validate Equivalency upload
  const validateEquivalency = () => {
    let isValid = true;
    let errorTmp = Array.isArray(error) ? [...error] : [{}]; // Ensure array

    // Reset error first
    errorTmp[0].amount = '';

    // Check empty
    if (!amount || String(amount).trim() === '') {
      errorTmp[0].amount = t('Amount is required');
      isValid = false;
    }
    // Check valid number (integer or decimal)
    else if (!/^\d+(\.\d+)?$/.test(String(amount))) {
      errorTmp[0].amount = t('Amount must be a valid number');
      isValid = false;
    }
    // Optional: ensure positive number
    else if (parseFloat(amount) <= 0) {
      errorTmp[0].amount = t('Amount must be greater than 0');
      isValid = false;
    }
    if (!amount || String(amount).trim() === '') {
      errorTmp[0].point = t('Point is required');
      isValid = false;
    }
    // Check valid number (integer or decimal)
    else if (!/^\d+(\.\d+)?$/.test(String(amount))) {
      errorTmp[0].point = t('Point must be a valid number');
      isValid = false;
    }
    // Optional: ensure positive number
    else if (parseFloat(amount) <= 0) {
      errorTmp[0].point = t('Point must be greater than 0');
      isValid = false;
    }

    setError(errorTmp);

    if (isValid) {
      saveEquivalency();
    }
  };

  //save equivalency api call
  const saveEquivalency = async () => {
    setLoading(true)

    const param = {
      point: point,
      adminId: adminData['adminId'],
      amount: amount,
    }

    var res = await fetchData('admin/savepointsequivalency', param)

    if (res.status == '200') {
      setLoading(false)

      equivalencyDataApiCall()
      toastsuccessmsg(res.message)
    } else {
      setLoading(false)
      toasterrormsg(res.message)
    }
  }

  useEffect(() => {
    equivalencyDataApiCall()
  }, [])

  return (
    <>
      <ToastContainer />
      <div className='container'>
        <div className='row mt-5'>
          <div className="col-12">
            <label className="h3">{t("Points Equivalency")}</label>
          </div>

          <div className="row g-3 align-items-center mt-3">
            {/* First Input */}
            <div className="col-12 col-md-auto">
              <input
                type="text"
                className="form-control"
                placeholder="Enter amount"
                value={point}
                onChange={(event: any) => {
                  setPoint(event.target.value);
                  removeError("point");
                }}
              />
              {error && error[0]?.point && (
                <label className="text-danger mt-1">{error[0].point}</label>
              )}
            </div>

            {/* Middle Text */}
            <div className="col-12 col-md-auto">
              <span className="fs-5 fw-bold">{t("Points equal to")}</span>
            </div>

            {/* Second Input */}
            <div className="col-12 col-md-auto mt-0">
              <PriceInput
                labelClass="fs-6 form-label "
                inputClass="form-control  border-right-0"
                placeholder={t("Enter Amount")}
                value={amount}
                onChange={(event: any) => {                  
                  setAmount(event);
                  removeError("amount");
                }}
              />
              {error && error[0]?.amount && (
                <label className="text-danger mt-1">{error[0].amount}</label>
              )}
            </div>

            {/* Currency */}


            {/* Save Button */}
            <div className="col-12 col-md-auto">
              <button
                type="button"
                disabled={loading}
                className="btn btn-success w-100 w-md-auto"
                onClick={validateEquivalency}
              >
                <span className="indicator-label">{t("Save")}</span>
                {loading && (
                  <span
                    className="spinner-border spinner-border-sm mx-2"
                    role="status"
                    aria-hidden="true"
                  ></span>
                )}
              </button>
            </div>
          </div>

          <hr />
          <div className='col-12'>
            <label className='h3'>{t('Booking')}</label>
          </div>
          <table className='table'>
            <thead>
              <tr>
                <th scope='col'></th>
                <th scope='col' className='fs-4 fw-bold'>
                  {t('Points')}
                </th>
                <th scope='col' className='fs-4 fw-bold'>
                  {t('Availability')}
                </th>
                <th scope='col'></th>
              </tr>
            </thead>
            <tbody>
              {pointSystemList.map((item: any, index: any) => {
                return (
                  <>
                    <tr>
                      <td>
                        <label className='d-inline-block'>
                          <span className='fs-4 fw-bold d-inline-block'>{t('For Every UZS')} </span>
                          <input
                            type='text'
                            className='form-control form-control-solid d-inline-block mw-150px'
                            placeholder='Amount'
                            value={item.amount}
                            onChange={(e: any) => {
                              const val = String(e.target.value ?? "");
                              if ((val && val.match(/^\d+$/)) || val === "") {
                                onchange(
                                  "amount",
                                  val.replace(/^0+(?=\d)/, "") || "0", // Keep as string
                                  index
                                );
                              }
                            }}
                          />
                          <span className='fs-4 fw-bold d-inline-block'> {t('or')} </span>{' '}
                          <select
                            className='form-select form-select-solid d-inline-block mw-150px'
                            defaultChecked={item.compare}
                            value={item.compare}
                            onChange={(e: any) => {
                              onchange('compare', e.target.value, index)
                            }}
                          >
                            <option value={'Grater Than Equal to'}>Grater Than Equal to</option>
                            <option value={'Equal to'}>Equal to</option>
                          </select>
                        </label>
                      </td>
                      <td>
                        <input
                          type='text'
                          className='form-control form-control-solid w-80px'
                          placeholder='Enter Point'
                          value={item.point}
                          onChange={(e: any) => {
                            onchange('point', e.target.value.replace(/^0+(?=\d)/, '') || 0, index)
                          }}
                        />
                      </td>
                      <td className='d-flex align-items-center'>
                        <input
                          type='text'
                          className='form-control form-control-solid w-80px'
                          placeholder='Availability'
                          value={item.availability}
                          onChange={(e: any) => {
                            onchange(
                              'availability',
                              e.target.value.replace(/^0+(?=\d)/, '') || 0,
                              index
                            )
                          }}
                        />
                        &nbsp;&nbsp;{' '}
                        <span className='fw-bold'>
                          {item.availability > 2 ? 'Months' : 'Month'}
                        </span>
                      </td>
                      <td>
                        {index > 0 && (
                          <button
                            className='btn btn-danger'
                            onClick={() => {
                              removebookingrow(index)
                            }}
                          >
                            <FontAwesomeIcon icon={faMinus} />
                          </button>
                        )}
                      </td>
                    </tr>
                  </>
                )
              })}

              <tr>
                <td colSpan={3}></td>
                <td>
                  <button
                    className='btn btn-success'
                    onClick={() => {
                      addbookingrow()
                    }}
                  >
                    <FontAwesomeIcon icon={faPlus} />
                  </button>
                </td>
              </tr>
              {bonusList && [...bonusList] // clone to avoid mutating state
                .sort((a: any, b: any) => Number(a.amount) - Number(b.amount)) // sort ascending by amount
                .map((item: any, index: number) => (
                  <tr key={item.loyaltysettingId}>
                    <td>
                      <label className="d-inline-block">
                        <span className="fs-4 fw-bold d-inline-block">
                          {t(`${item.label} level members earn`)}
                        </span>
                        <input
                          type="text"
                          className="form-control form-control-solid d-inline-block mw-80px"
                          placeholder="Amount"
                          value={item.amount ?? 0}
                          onChange={(e: any) => {
                            const val = e.target.value;
                            if ((/^\d+$/.test(val) || val === "") && Number(val) <= 100) {
                              const tmp: any = [...bonusList];
                              const originalIndex = bonusList.findIndex(
                                (b: any) => b.loyaltysettingId === item.loyaltysettingId
                              );
                              tmp[originalIndex] = {
                                ...tmp[originalIndex],
                                amount: val.replace(/^0+(?=\d)/, "") || 0,
                              };
                              setBonusList(tmp);
                            }
                          }}
                        />
                        <span className="fs-4 fw-bold d-inline-block">
                          {t("% more Points.")}
                        </span>
                      </label>
                    </td>
                  </tr>
                ))}

              <tr>
                <td colSpan={4} style={{ textAlign: 'right' }}>
                  {menuIdEdit ? <button
                    className='btn btn-success'
                    onClick={() => {
                      onSubmit('booking')
                    }}
                  >
                    {t('Save')}
                  </button> : ""}
                </td>
              </tr>
            </tbody>
          </table>

          <hr />
          <div className='col-12'>
            <label className='h3'>{t('Reviews')}</label>
            <table className='table'>
              <thead>
                <tr>
                  <th scope='col'></th>
                  <th scope='col' className='fs-4 fw-bold'>
                    {t('Points')}
                  </th>
                  <th scope='col' className='fs-4 fw-bold'>
                    {t('Availability')}
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <th scope='row'>
                    <p className='fs-5 fw-bold'>{t('Under 20 characters')}</p>
                  </th>
                  <td>
                    <input
                      type='text'
                      className='form-control form-control-solid w-80px'
                      placeholder={t('Enter Point')}
                      value={reviewsList.length > 0 ? reviewsList[0]['point'] : 0}
                      onChange={(e: any) => {
                        var tmp: any = [...reviewsList]
                        tmp[0]['point'] = checkwithremovemonth(e.target.value, tmp[0]['point'])
                        setReviewsList(tmp)
                      }}
                    />
                  </td>
                  <td className='d-flex align-items-center'>
                    <input
                      type='text'
                      className='form-control form-control-solid w-80px'
                      placeholder={t('Enter Availability')}
                      value={reviewsList.length > 0 ? reviewsList[0]['availability'] : 0}
                      onChange={(e: any) => {
                        var tmp: any = [...reviewsList]
                        tmp[0]['availability'] = checkwithremovemonth(
                          e.target.value,
                          tmp[0]['availability']
                        )
                        setReviewsList(tmp)
                      }}
                    />
                    &nbsp;&nbsp;{' '}
                    <span className='fw-bold'>
                      {reviewsList.length > 0
                        ? reviewsList[0]['availability'] > 2
                          ? t('Months')
                          : 'Month'
                        : ''}
                    </span>
                  </td>
                </tr>
                <tr>
                  <th scope='row'>
                    <p className='fs-5 fw-bold'>{t('20-50 characters')}</p>
                  </th>
                  <td>
                    <input
                      type='text'
                      className='form-control form-control-solid w-80px'
                      placeholder={t('Enter Point')}
                      value={reviewsList.length > 0 ? reviewsList[1]['point'] : 0}
                      onChange={(e: any) => {
                        var tmp: any = [...reviewsList]
                        tmp[1]['point'] = checkwithremovemonth(e.target.value, tmp[1]['point'])
                        setReviewsList(tmp)
                      }}
                    />
                  </td>
                  <td className='d-flex align-items-center'>
                    <input
                      type='text'
                      className='form-control form-control-solid w-80px'
                      placeholder={t('Enter Availability')}
                      value={reviewsList.length > 0 ? reviewsList[1]['availability'] : 0}
                      onChange={(e: any) => {
                        var tmp: any = [...reviewsList]
                        tmp[1]['availability'] = checkwithremovemonth(
                          e.target.value,
                          tmp[1]['availability']
                        )
                        setReviewsList(tmp)
                      }}
                    />
                    &nbsp;&nbsp;{' '}
                    <span className='fw-bold'>
                      {reviewsList.length > 0
                        ? reviewsList[1]['availability'] > 2
                          ? t('Months')
                          : t('Month')
                        : ''}
                    </span>
                  </td>
                </tr>
                <tr>
                  <th scope='row'>
                    <p className='fs-5 fw-bold'>{t('Over 50 characters')}</p>
                  </th>
                  <td>
                    <input
                      type='text'
                      className='form-control form-control-solid w-80px'
                      placeholder={t('Enter Point')}
                      value={reviewsList.length > 0 ? reviewsList[2]['point'] : 0}
                      onChange={(e: any) => {
                        var tmp: any = [...reviewsList]
                        tmp[2]['point'] = checkwithremovemonth(e.target.value, tmp[2]['point'])
                        setReviewsList(tmp)
                      }}
                    />
                  </td>
                  <td className='d-flex align-items-center'>
                    <input
                      type='text'
                      className='form-control form-control-solid w-80px'
                      placeholder={t('Enter Availability')}
                      value={reviewsList.length > 0 ? reviewsList[2]['availability'] : 0}
                      onChange={(e: any) => {
                        var tmp: any = [...reviewsList]
                        tmp[2]['availability'] = checkwithremovemonth(
                          e.target.value,
                          tmp[2]['availability']
                        )
                        setReviewsList(tmp)
                      }}
                    />
                    &nbsp;&nbsp;{' '}
                    <span className='fw-bold'>
                      {reviewsList.length > 0
                        ? reviewsList[2]['availability'] > 2
                          ? t('Months')
                          : t('Month')
                        : ''}
                    </span>
                  </td>
                </tr>
                <tr>
                  <th scope='row'>
                    <p className='fs-5 fw-bold'>{t('Upload an image or video')}</p>
                  </th>
                  <td>
                    <input
                      type='text'
                      className='form-control form-control-solid w-80px'
                      placeholder={t('Enter Point')}
                      value={reviewsList.length > 0 ? reviewsList[3]['point'] : 0}
                      onChange={(e: any) => {
                        var tmp: any = [...reviewsList]
                        tmp[3]['point'] = checkwithremovemonth(e.target.value, tmp[3]['point'])
                        setReviewsList(tmp)
                      }}
                    />
                  </td>
                  <td className='d-flex align-items-center'>
                    <input
                      type='text'
                      className='form-control form-control-solid w-80px'
                      placeholder={t('Enter Availability')}
                      value={reviewsList.length > 0 ? reviewsList[3]['availability'] : 0}
                      onChange={(e: any) => {
                        var tmp: any = [...reviewsList]
                        tmp[3]['availability'] = checkwithremovemonth(
                          e.target.value,
                          tmp[3]['availability']
                        )
                        setReviewsList(tmp)
                      }}
                    />
                    &nbsp;&nbsp;{' '}
                    <span className='fw-bold'>
                      {reviewsList.length > 0
                        ? reviewsList[3]['availability'] > 2
                          ? t('Months')
                          : t('Month')
                        : ''}
                    </span>
                  </td>
                </tr>
                <tr>
                  <td colSpan={3} style={{ textAlign: 'right' }}>
                    {menuIdEdit ? <button className='btn btn-success' onClick={() => onSubmit('review')}>
                      {t('Save')}
                    </button> : ""}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          {/* Reviews section end */}

          <hr />
          {/* Explore Posts section start */}
          <div className='col-12'>
            <label className='h3'>{t('Explore Posts')}</label>
            <div className="table-responsive mt-5">
              <table className="table">
                <thead>
                  <tr>
                    <th scope='col' className='fs-4 fw-bold'>
                      {t('Badge Level')}
                    </th>
                    <th scope='col' className='fs-4 fw-bold'>
                      {t('Type')}
                    </th>
                    <th scope='col' className='fs-4 fw-bold'>
                      {t('Points')}
                    </th>
                    <th scope='col' className='fs-4 fw-bold'>
                      {t('Recognition')}
                    </th>
                    <th scope='col' className='fs-4 fw-bold'>
                      {t('Availability')}
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {data.map((item: any, index: any) => (
                    <tr>
                      <th scope='row'>
                        <label className='fs-5'>
                          <label className={`fs-4 fw-bold ${index == 0 ? 'mt-6' : ''}`}>
                            {item.badges}
                          </label>
                          <br />

                          {item.upgradedtasks.map((task: any, taskIndex: any) => (
                            <>
                              <label className='fs-5 mt-5'>
                                {task.title == 'Complete Profile Details' ? '' : task.title}
                              </label>
                              <br />
                            </>
                          ))}

                          <br />
                        </label>
                      </th>
                      <td>
                        <label className='fs-5'>
                          <label className='fs-4 fw-bold'></label>
                          <br />

                          {item.upgradedtasks.map((task: any, taskIndex: any) => (
                            <>
                              {index == 0 ? (
                                <label className='mt-3'>{t("New Sign Up")}</label>
                              ) : task.title == 'Complete Profile Details' ? (
                                ''
                              ) : (
                                <input
                                  readOnly
                                  type='text'
                                  className='form-control form-control-solid w-80px  fw-bold'
                                  placeholder='Enter Point'
                                  value={task.value}
                                />
                              )}
                              <br />
                            </>
                          ))}

                          <br />
                        </label>
                      </td>
                      <td>
                        <div style={{ marginTop: '10%' }}>
                          <input
                            type='text'
                            className='form-control form-control-solid w-80px mt-5 fw-bold'
                            placeholder='Enter Point'
                            value={item.reward}
                            onChange={(e) => handleChange(index, 'reward', e.target.value)}
                          />
                        </div>
                      </td>
                      <td>
                        <label className='fs-5 mt-5 fw-Bold'>
                          {index == 0 ? 'Badge' : item.recognition}
                        </label>
                        <br />
                      </td>
                      <td className='d-flex align-items-center'>
                        <input
                          type='text'
                          className='form-control form-control-solid w-80px'
                          placeholder='Enter Availability'
                          value={explorePostList.length > 0 ? explorePostList[0]['availability'] : 0}
                          onChange={(e: any) => {
                            var tmp: any = [...explorePostList]
                            tmp[0]['availability'] = checkwithremovemonth(
                              e.target.value,
                              tmp[0]['availability']
                            )
                            setExplorePostList(tmp)
                          }}
                        />
                        &nbsp;&nbsp;{' '}
                        <span className='fw-bold'>
                          {explorePostList.length > 0 && explorePostList[0]['availability'] > 2
                            ? t('Months')
                            : t('Month')}
                        </span>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
            <div style={{ textAlign: 'right' }}>
              {menuIdEdit ? <button
                className='btn btn-success'
                onClick={() => {
                  onSubmit2()
                }}
              >
                {t('Save')}
              </button> : ""}
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default PointSystem
